import { Phone, Mail } from "lucide-react";
import { SITE } from "../data/site";

export default function StickyBar() {
  return (
    <div
      data-testid="sticky-contact-bar"
      className="fixed bottom-0 inset-x-0 z-50 border-t border-amber/40 bg-ink/90 backdrop-blur-xl"
    >
      <div className="grid grid-cols-2">
        <a
          href={SITE.phoneHref}
          data-testid="sticky-phone-btn"
          className="flex items-center justify-center gap-2 py-3.5 font-display font-bold uppercase tracking-widest text-sm sm:text-base text-amber hover:bg-amber hover:text-ink transition-colors duration-300"
        >
          <Phone className="w-4 h-4" />
          {SITE.phone}
        </a>
        <a
          href={SITE.emailHref}
          data-testid="sticky-email-btn"
          className="flex items-center justify-center gap-2 py-3.5 font-display font-bold uppercase tracking-widest text-sm sm:text-base text-amber border-l border-amber/40 hover:bg-amber hover:text-ink transition-colors duration-300"
        >
          <Mail className="w-4 h-4" />
          <span className="hidden min-[420px]:inline">{SITE.email}</span>
          <span className="min-[420px]:hidden">Email Us</span>
        </a>
      </div>
    </div>
  );
}
